import { connect } from 'react-redux'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import TwitterLogin from 'react-twitter-login'

import {
  getFacebookAppId,
  getTwitterConsumerKey,
  getTwitterConsumerSecret,
  getTwitterCallback,
  getTwitterLoginEnabled,
  getFacebookEnabled,
} from 'selectors/app'
import styles from './style.css'

const SocialAuth = ({
  facebookEnabled,
  facebookAppId,
  twitterLoginEnabled,
  twitterConsumerKey,
  twitterConsumerSecret,
  twitterCallbackUrl,
  onFacebookSuccess,
}) => {
  const responseFacebook = response => {
    const { id, name, email } = response
    const username = name.replace(/\s+/g, '')

    onFacebookSuccess(id, email, username)
  }

  const responseTwitter = (err, data) => {
    console.log('err => ', err)
    console.log('data => ', data)
  }

  return (
    <div className={styles['social-row']}>
      {facebookEnabled && (
        <div className={styles['social-btn__wrap']}>
          <FacebookLogin
            appId={facebookAppId}
            fields="name,email"
            callback={responseFacebook}
            render={renderProps => (
              <div
                className={`${styles['social-btn']} ${styles['fb-btn']}`}
                onClick={renderProps.onClick}
              >
                Facebook
              </div>
            )}
          />
        </div>
      )}
      {/* {twitterLoginEnabled && (
        <div className={styles['social-btn__wrap']}>
          <TwitterLogin
            authCallback={responseTwitter}
            consumerKey={twitterConsumerKey}
            consumerSecret={twitterConsumerSecret()}
            callbackUrl={twitterCallbackUrl}
            // callbackUrl={'http://192.168.100.3/twitter'}
            // eslint-disable-next-line react/no-children-prop
            children={
              <div className={`${styles['social-btn']} ${styles['twitter-btn']}`}>
                Twitter
              </div>
            }
          />
        </div>
      )} */}
    </div>
  )
}

const mapStateToProps = state => ({
  facebookEnabled: getFacebookEnabled(state),
  facebookAppId: getFacebookAppId(state),
  twitterConsumerKey: getTwitterConsumerKey(state),
  twitterConsumerSecret: getTwitterConsumerSecret(state),
  twitterCallbackUrl: getTwitterCallback(state),
  twitterLoginEnabled: getTwitterLoginEnabled(state),
})

export default connect(mapStateToProps)(SocialAuth)
